
import { memo, useState, useEffect } from "react";

import {
  IFuncionalidade,
  IOperacao,
  IProduto,
} from "../../../shared/services/api/permissoes/PermissoesService";
import {
  RichTreeView,
  TreeViewBaseItem,
} from "@gvdasa/react-components";

interface ITreeViewDeModulos {
  produto: IProduto;
  handleValoresCheckbox: (event, funcionalidade, id) => void;
  erroAoSalvarPermissoes: boolean;
  mensagemDeErroPermissoes: string;
  disabled: boolean;
  handleMarcarTodos: (
    e: React.ChangeEvent<HTMLInputElement>,
    modulo: {
      id: string;
      nome: string;
      funcionalidades: IFuncionalidade[];
    },
    produto: IProduto
  ) => void;
  filtro: boolean;
  filtrosPorOperacao: IOperacao[];
  apenasProdutosPermissoesHabilitadas: (produtos: IProduto[]) => IProduto[];
  produtos: IProduto[];
  setFiltrado: React.Dispatch<React.SetStateAction<boolean>>;
  filtrado: boolean;
}

export const TreeViewDeModulos: React.FC<ITreeViewDeModulos> = memo(
  ({
    produto,
    filtrosPorOperacao,
  }) => {
    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    const handleSelectedItemsChange = (
      event: React.SyntheticEvent | null,
      itemIds: string | string[] | null,
    ) => {
      const newSelection = itemIds
        ? Array.isArray(itemIds)
          ? itemIds
          : [itemIds]
        : [];
      setSelectedItems(newSelection);

      // Atualizar temPermissao nas operações conforme seleção
      produto.modulos.forEach(modulo => {
        modulo.funcionalidades.forEach(funcionalidade => {
          funcionalidade.operacoes.forEach(operacao => {
            const id = `${modulo.id}${funcionalidade.id}${operacao.id}`;
            operacao.temPermissao = newSelection.includes(id);
          });
        });
      });
    };

    const treeData: TreeViewBaseItem[] = produto.modulos.map((modulo) => ({
      id: modulo.id,
      label: modulo.nome,
      checkboxSelection: true,
      children: modulo.funcionalidades.map((funcionalidade) => ({
        id: `${modulo.id}${funcionalidade.id}`,
        label: funcionalidade.nome,
        checkboxSelection: true,
        children: funcionalidade.operacoes.map((operacao) => ({
          id: `${modulo.id}${funcionalidade.id}${operacao.id}`,
          label: operacao.nome,
          disabled:
            filtrosPorOperacao.length > 0 &&
            !filtrosPorOperacao.some(
              (fo) => fo.nome === operacao.nome
            ),
          checkboxSelection: true,
          temPermissao: operacao.temPermissao,
        })),
      })),
    }));


  // Inicializar seleção com base em temPermissao
  useEffect(() => {
    const initialSelection: string[] = [];
    treeData.forEach(module => {
      (module.children ?? []).forEach(funcionalidade => {
        (funcionalidade.children ?? [])
          .filter(item => (item as any).temPermissao)
          .forEach(item => initialSelection.push(item.id));
      });
    });
   // Marcar funcionalidades cujo todos os filhos estão selecionados
   treeData.forEach(module => {
     (module.children ?? []).forEach(funcionalidade => {
       const childIds = (funcionalidade.children ?? []).map(item => item.id);
       if (childIds.length > 0 && childIds.every(id => initialSelection.includes(id))) {
         initialSelection.push(funcionalidade.id);
       }
     });
   });
   // Marcar módulos cujo todas as funcionalidades estão selecionadas
   treeData.forEach(module => {
     const funcIds = (module.children ?? []).map(func => func.id);
     if (funcIds.length > 0 && funcIds.every(id => initialSelection.includes(id))) {
       initialSelection.push(module.id);
     }
   });
    setSelectedItems(initialSelection);
  }, [produto.modulos]);

    const funcionalidadesFiltradas: IFuncionalidade[] = [];
    produto.modulos.flatMap((m) =>
      m.funcionalidades.filter((f) =>
        f.operacoes.filter((o) => {
          filtrosPorOperacao.flatMap((fo) => {
            if (fo === o) {
              funcionalidadesFiltradas.push(f);
            }
          });
        })
      )
    );


    return (
    
      <RichTreeView
        items={treeData}
        getItemId={(item) => item.id}
        getItemLabel={(item) => item.label}
        multiSelect
        checkboxSelection
        selectionPropagation={{ parents: true, descendants: true }}
        selectedItems={selectedItems}
        onSelectedItemsChange={handleSelectedItemsChange}
        defaultExpandedItems={treeData.map(item => item.id)}
        sx={{
          '& .MuiTreeItem-content.Mui-selected': {
            backgroundColor: 'transparent !important',
            '&:hover': {
              backgroundColor: 'transparent !important',
            },
            '&.Mui-focused': {
              backgroundColor: 'transparent !important',
            }
          },
          '& .MuiTreeItem-content.Mui-selected.Mui-focused': {
            backgroundColor: 'transparent !important',
          }
        }}
      />
    );
  }
);
